export const initErpData = () => {
  return { type: "INIT_ERP_DATA" };
};

export const fetchErpData = data => ({
  type: "FETCH_ERP_DATA",
  payload: data
});



// WEBPACK FOOTER //
// ./src/actions/actions/erp-data.js